import React, {ReactElement} from 'react';
import {Grid} from '@mui/material';
import useIsMobile from 'hooks/useIsMobile';

type EventInfoRowProps = {
  title: string;
  source: string | ReactElement;
};

const EventInfoRow = (props: EventInfoRowProps) => {
  const {title, source} = props;
  const isMobile = useIsMobile();

  return (
    <React.Fragment>
      <Grid size={12} sx={{mb: isMobile ? 0.5 : 2}} container>
        <Grid size={6}>
          {title}
        </Grid>
        <Grid size={6}>
          {source}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default EventInfoRow;
